import { convertNumberToDisplayedNumberText } from "./Numbers";

export interface Dimension {
  length: number;
  width: number;
  depth: number;
}

export interface Price {
  base: number;
  adjustment?: number;
  effective: number|null;
}

export interface Identifiable {
  id: number;
}

export interface NamedIdentifiable
extends Identifiable {
  name: string;
}

export interface AuditableNamedIdentifiable
extends NamedIdentifiable {
  modificationTime?: string;
}

export interface ItemCompletedOrderRecord {
  name: string;
  latestCompletionDate?: string;
}

export const sortDimensions = (dimension: Dimension) => {
  const dimensions = [dimension.length, dimension.width, dimension.depth];
  dimensions.sort((a, b) => a - b);
  return dimensions;
};

export const getDimensionsDisplayText = (dimension: Dimension) : string =>
  sortDimensions(dimension).map(convertNumberToDisplayedNumberText).join('x');

export const areDimensionsEqual = (dimension: Dimension, anotherDimension: Dimension) => {
  const dimensionArray = sortDimensions(dimension);
  const anotherDimensionArray = sortDimensions(anotherDimension);
  return dimensionArray[0] === anotherDimensionArray[0]
    && dimensionArray[1] === anotherDimensionArray[1]
    && dimensionArray[2] === anotherDimensionArray[2];
};

export const convertToIdIndexedArray = <T extends Identifiable>(items: T[]): T[] => {
  const idIndexedItemArray: T[] = [];
  items.forEach(item => {
    idIndexedItemArray[item.id] = item;
  });
  return idIndexedItemArray;
};